import React from "react";
import {StyledInputField} from "./styles";
import PropTypes from "prop-types";

const InputField = props => {
    const {id, value, onChange, handleChange, handleBlur, type, placeholder, error, inputRef, disabled} = props;

    return (<StyledInputField
        id={id}
        name={id}
        ref={inputRef}
        type={type || 'text'}
        value={value}
        onChange={handleChange || (e => {if(onChange) { onChange(e.target.value);}})}
        onBlur={handleBlur}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
    />);
}

InputField.propTypes = {
    id: PropTypes.string,
    value: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    onChange: PropTypes.func,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    inputRef: PropTypes.object,
}

export default InputField;
